<script lang="ts">
  import { Router, Route } from 'svelte-routing'
  // svelte-routing matches nested <Route>s against their nearest <Router>'s
  // basepath. The admin section needs its own <Router> so its child routes
  // resolve relative to /admin (the parent Route strips the /* to form the base).
  import Login from './routes/Login.svelte'
  import AdminLayout from './routes/admin/AdminLayout.svelte'
  import Dashboard from './routes/admin/Dashboard.svelte'
  import People from './routes/admin/People.svelte'
  import Animals from './routes/admin/Animals.svelte'
  import Occupancies from './routes/admin/Occupancies.svelte'
  import PropertyManagers from './routes/admin/PropertyManagers.svelte'
  import Units from './routes/admin/Units.svelte'
  import RevenueAudit from './routes/admin/RevenueAudit.svelte'
  import AssistanceRequests from './routes/admin/AssistanceRequests.svelte'
  import Leads from './routes/admin/Leads.svelte'
  import Users from './routes/admin/Users.svelte'
  import PublicLayout from './routes/public/PublicLayout.svelte'
  import LandingPage from './routes/public/LandingPage.svelte'
  import ProvidersPage from './routes/public/ProvidersPage.svelte'
  import Wizard from './routes/public/Wizard.svelte'
  import ThankYou from './routes/public/ThankYou.svelte'
  import Portal from './routes/public/Portal.svelte'
  import Embed from './routes/embed/Embed.svelte'
  import SetPassword from './routes/public/SetPassword.svelte'
  import ErrorToast from './components/ErrorToast.svelte'
</script>

<Router>
  <Route path="/login"><Login /></Route>
  <Route path="/set-password"><SetPassword /></Route>
  <Route path="/admin/*">
    <AdminLayout>
      <Router>
        <Route path="/"><Dashboard /></Route>
        <Route path="/people"><People /></Route>
        <Route path="/animals"><Animals /></Route>
        <Route path="/occupancies"><Occupancies /></Route>
        <Route path="/property-managers"><PropertyManagers /></Route>
        <Route path="/units"><Units /></Route>
        <Route path="/revenue-audit"><RevenueAudit /></Route>
        <Route path="/assistance-requests"><AssistanceRequests /></Route>
        <Route path="/leads"><Leads /></Route>
        <Route path="/users"><Users /></Route>
      </Router>
    </AdminLayout>
  </Route>
  <Route path="/thank-you">
    <PublicLayout>
      <ThankYou />
    </PublicLayout>
  </Route>
  <Route path="/portal">
    <PublicLayout>
      <Portal />
    </PublicLayout>
  </Route>
  <Route path="/register/:pmSlug/:propertySlug" let:params>
    <PublicLayout>
      <Wizard pmSlug={params.pmSlug} propertySlug={params.propertySlug} />
    </PublicLayout>
  </Route>
  <Route path="/register">
    <PublicLayout>
      <Wizard />
    </PublicLayout>
  </Route>
  <Route path="/embed/:token" let:params>
    <Embed token={params.token ?? ''} />
  </Route>
  <Route path="/providers">
    <ProvidersPage />
  </Route>
  <Route path="/">
    <LandingPage />
  </Route>
</Router>

<ErrorToast />
